import styled from 'styled-components';

export const SidebarPlaceholder = styled.div`
  padding-top: 16px;
`;

export { default as SidebarFiltersSection } from './section';
export { LinkList as SidebarFiltersLinkList, ListItem as SidebarFiltersLinkListItem } from './link-list';
